import React from 'react';
import cn from 'classnames';
import { BackgroundSection } from 'components/background/BackgroundSection';

import s from './Pipeline.module.scss';

type Props = {
  title?: React.ReactNode;
  text?: React.ReactNode;
  footnotes?: React.ReactNode;
  steps?: string[];
  children: React.ReactNode;
};

export const Pipeline = ({ title, text, footnotes, steps, children }: Props) => {
  return (
    <BackgroundSection>
      <div className={s.pipeline__segment}>
        <div className={s.pipeline__container}>
          {title && <div className={s.pipeline__title}>{title}</div>}
          {text && (
            <div className={s.pipeline__row}>
              <div className={s.pipeline__text}>{text}</div>
            </div>
          )}

          <ul className={cn(s.pipeline__items, { [s.noCopy]: !title && !text })}>
            {steps
              ? React.Children.map(children, (child) => {
                  return React.cloneElement(child as any, { steps });
                })
              : children}
          </ul>

          {footnotes && <div className={s.pipeline__footnotes}>{footnotes}</div>}
        </div>
      </div>
    </BackgroundSection>
  );
};
